import { render } from "./EditorLink.vue?vue&type=template&id=3d8f504a"
import script from "./EditorLink.vue?vue&type=script&lang=js"
export * from "./EditorLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__